var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgNewClient = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.75V6.25C9.5 6.38807 9.38807 6.5 9.25 6.5H6.5V9.25C6.5 9.38807 6.38807 9.5 6.25 9.5H5.75C5.61193 9.5 5.5 9.38807 5.5 9.25V6.5H2.75C2.61193 6.5 2.5 6.38807 2.5 6.25V5.75C2.5 5.61193 2.61193 5.5 2.75 5.5H5.5V2.75C5.5 2.61193 5.61193 2.5 5.75 2.5H6.25C6.38807 2.5 6.5 2.61193 6.5 2.75V5.5H9.25C9.38807 5.5 9.5 5.61193 9.5 5.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 15H25V13C25 11.8954 24.1046 11 23 11H17C15.8954 11 15 11.8954 15 13V15H12C10.8954 15 10 15.8954 10 17V27C10 28.1046 10.8954 29 12 29H28C29.1046 29 30 28.1046 30 27V17C30 15.8954 29.1046 15 28 15ZM22 22C22 22.5523 21.5523 23 21 23H19C18.4477 23 18 22.5523 18 22V21.5C18 21.2239 18.2239 21 18.5 21H21.5C21.7761 21 22 21.2239 22 21.5V22ZM17 15H23V13H17V15Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewClient, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NewClient.422b7eaf.svg";
export { ForwardRef as ReactComponent };